import { observer } from 'mobx-react-lite';
import { common } from '@featit/shared/i18n/messages/en/common';
import { ConfirmationToast } from '@/components/ConfirmationToast';
import { registerEnglishArea } from '@/i18n/catalogue';
import { useT } from '@/i18n/LocaleProvider';
import { invitationJoinedNotice } from './invitationJoinedNoticeStore';

registerEnglishArea('common', common);

/**
 * F-0584 MWI-15 (I-1935): after Join in the person's own list, the places joined and each place not
 * added, with its reason. Mounted once (`Layout.tsx`), so it survives the navigation the Join causes.
 */
export const InvitationJoinedNotice = observer(function InvitationJoinedNotice() {
  const t = useT();
  const notice = invitationJoinedNotice.notice;
  if (!notice) return null;
  return (
    <ConfirmationToast
      testId="invitation-joined-notice"
      message={
        <>
          <span className="block font-medium">
            {notice.refusal
              ? notice.refusal
              : notice.agency
                ? t('common.invitationJoined.agency', { agency: notice.agency })
                : t('common.invitationJoined.joined', { places: notice.places })}
          </span>
          <span data-testid="invitation-skipped" className="block">
            {notice.skipped.map((line) => (
              <span key={line} className="block">
                {line}
              </span>
            ))}
          </span>
        </>
      }
      action={{
        label: t('common.invitationJoined.dismiss'),
        testId: 'invitation-joined-notice-dismiss',
        onClick: () => invitationJoinedNotice.dismiss(),
      }}
    />
  );
});
